module.exports = __webpack_public_path__ + "353611697fada479a95786b54fd533ad.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-bold.woff
 ** module id = 16
 ** module chunks = 0
 **/